import React , {   useState ,useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import {  Table } from "@material-ui/core";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell"; 
import IconButton from '@mui/material/IconButton';
import TablePagination from "@material-ui/core/TablePagination"; 
import TableSortLabel from "@material-ui/core/TableSortLabel";
import Paper from "@material-ui/core/Paper";
import PropTypes from "prop-types"; 
import Skeleton from '@mui/material/Skeleton';
import Checkbox from '@mui/material/Checkbox';
import {IoClose ,IoCloseOutline} from "react-icons/io5";
import * as Actions from "../../store/action/payment.js";  
import { useDispatch, useSelector } from "react-redux"; 
import { useNavigate } from "react-router-dom"; 
import ToggleSwitch from '../../components/ToggleSwitch/ToggleSwitch.js'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import Dialog from "@material-ui/core/Dialog"; 
import Collapse from '@mui/material/Collapse'; 
import { AiOutlineEye } from "react-icons/ai";
import PaymentExpert from "../../components/TaskListSection/DynamicComponentTodoList/PaymentExpert";
import PaymentGarage from "../../components/TaskListSection/DynamicComponentTodoList/PaymentGarage";
import {translateReplacementCarStatus} from "../../utils/translateReplacementCarStatus";
import {CompleteMissionExpert , CompleteMissionRGA} from "../../store/action/wsPI.js";
import {addPaymentMissionExpert} from "../../store/action/missionExpert.js";
 
import { hasAuthorities } from "../../utils/authoritiesUtils";
 
function desc(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
      return -1;
    }
    if (b[orderBy] > a[orderBy]) {
      return 1;
    }
    return 0;
  }
  
  function stableSort(array, cmp) {
    const stabilizedThis = array?.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
      const order = cmp(a[0], b[0]);
      if (order !== 0) return order;
      return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
  }
  
  function getSorting(order, orderBy) {
    return order === "desc"
      ? (a, b) => desc(a, b, orderBy)
      : (a, b) => -desc(a, b, orderBy);
  }
function EnhancedTableHead(props) {
    const classes = useStyles();
    const { checkedGroupe ,onSelectAllClick, order, orderBy, numSelected, rowCount, onRequestSort } = props;

    const createSortHandler = (property) => (event) => {
      onRequestSort(event, property);
    };
  
    const headRows = [
      {
        id: "type",
        align: "left", 
        label: "Type",
      },
      {
        id: "claimNumber",
        align: "left", 
        label: "N° Sinistre",
      },
      
      {
        id: "" +
            "destinataire",
        align: "left", 
        label: "Destinataire",
      },
      {
        id: "montant",
        align: "left", 
        label: "Montant",},
      {
          id: "status",
          align: "center", 
          label: "Statuts",}
    ];
    const headRowsGropue = [
      {
        id: "claimNumber",
        align: "left", 
        label: "N° Sinistre",
      } ,
      
      {
        id: "total",
        align: "left", 
        label: "Total",
      },
       
      {
          id: "status",
          align: "center", 
          label: "Statuts",}
    ];
  
    return (
       
        <tr className={classes.tableHeadRows}>
          {checkedGroupe ?<> {headRowsGropue.map((row) => (
            <TableCell
              key={row.id}
              align={row.align} 
              sortDirection={orderBy === row.id ? order : false}       
              style={{  border:0 }}
            >
              <TableSortLabel
                active={true}
                direction={orderBy === row.id ? order : "desc"}
                onClick={createSortHandler(row.id)}
                style={{ whiteSpace: "nowrap" , fontFamily : 'Poppins', fontWeight : 600 ,fontSize :12, lineHeight:'18px' ,color :'rgba(181, 181, 195, 1)'  }}
              >
                {row.label}
              </TableSortLabel>
            </TableCell>
          ))}</> :
          <> 
            <TableCell padding="checkbox"
                       style={{ borderBottom: 'none' }} >
                <Checkbox
                    indeterminate={numSelected > 0 && numSelected < rowCount}
                    checked={rowCount > 0 && numSelected === rowCount}
                    onChange={onSelectAllClick}
                    sx={{
                            color: 'rgb(255, 255, 255)' ,
                            opacity: '.7' ,
                            width: '16px',
                            height: '16px' ,
                            gap: 0 ,
                            borderRadius:' 4px' ,
                            border: '1px solid' ,
                        }}
                />
            </TableCell>
          {headRows.map((row) => (
            <TableCell
              key={row.id}
              align={row.align} 
              sortDirection={orderBy === row.id ? order : false}       
              style={{  border:0 }}
            >
              <TableSortLabel
                active={true}
                direction={orderBy === row.id ? order : "desc"}
                onClick={createSortHandler(row.id)}
                style={{ whiteSpace: "nowrap" , fontFamily : 'Poppins', fontWeight : 600 ,fontSize :12, lineHeight:'18px' ,color :'rgba(181, 181, 195, 1)'  }}
              >
                {row.label}
              </TableSortLabel>
            </TableCell>
          ))}</>
        }
        <TableCell
              style={{  border:0 }}
            >
              {""}
            </TableCell> 
        </tr> 
    );
  }



  EnhancedTableHead.propTypes = {
    onRequestSort: PropTypes.func.isRequired, 
    orderBy: PropTypes.string.isRequired,
    //SrowCount: PropTypes.number,
    checkedGroupe: PropTypes.bool, 
    numSelected: PropTypes.number.isRequired, 
    onSelectAllClick: PropTypes.func.isRequired,
    order: PropTypes.oneOf(['asc', 'desc']).isRequired, 
    rowCount: PropTypes.number.isRequired,
  };
  const useStyles = makeStyles((theme) => ({
    root: {
      width: "100%",
      minHeight: "85vh"  
    },
    tableCellSmall: {  fontFamily : 'Poppins', fontWeight : 600 ,fontSize :14, lineHeight:'21px' ,color :'rgba(70, 78, 95, 1)' ,  borderBottom: '1px solid  rgba(0, 0, 0, 0.08)'    },
    tableCellSmallCollapseHead: {  fontFamily : 'Poppins', fontWeight : 600 ,fontSize :12, lineHeight:'18px' ,color :'rgba(74, 75, 104, 1)'    },
    tableCellSmallCollapse: {  fontFamily: 'Poppins', fontSize: '12px', lineHeight: '18px',fontWeight: 400,color :'rgba(70, 78, 95, 1)' ,      },
    paper: {
      width: "100%", 
      borderRadius : '11px', 
      boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.06)'
    },
 
    tableWrapper: { 
      padding :'40px'
    },
    tableHeadRows: { height: "43px" ,  background: 'rgba(243, 246, 249, 1)' , borderRadius : '6px' } ,
    titre :{ fontFamily: 'Poppins' ,fontSize: '13.8px',fontWeight: 600 , lineHeight: '20.7px' , color :  'rgba(63, 66, 84, 1)'} ,
    titreLabel :{marginLeft :'10px' ,fontFamily: 'Poppins',fontSize: '12px', fontWeight: 500, lineHeight: '18px' ,color :'rgba(32, 18, 70, 1)'  },
    tablePagination:{fontFamily: 'Poppins',fontSize: '12px', fontWeight: 400, lineHeight: '18px' ,color :'rgba(32, 18, 70, 1)'},
    selectInput :{ 
      border: '0.61px solid rgba(226, 217, 239, 1)', 
      background: 'rgba(255, 255, 255, 1)', 
      width: '85%',
      height: '30px', 
      borderRadius: 5, 
      marginLeft: '10px', 
      fontFamily: 'Poppins', 
      fontSize: '10px',
    },
    filterInput: {
      border: '0.61px solid rgba(226, 217, 239, 1)',
      background: 'rgba(255, 255, 255, 1)',
      width: '100%',
      height: '30px',
      borderRadius: 5,
      marginLeft: '10px',
      fontFamily: 'Poppins',
      fontSize: '10px',
      padding: '0 10px'
    },
    filterContainer: {
      display: 'flex',
      flexDirection: 'row',
      gap: '20px',
      alignItems: 'center',
      flex: 1
    },
    filterRow: {
      display: 'flex',
      gap: '20px',
      alignItems: 'center'
    },
    filterItem: {
      display: 'flex',
      flexDirection: 'column',
      gap: '5px',
      width: '180px'
    },
    optionItem: {
      width: '150px',
      padding: '10px',
      cursor: 'pointer',
      backgroundColor: 'white',
      color: 'rgba(32, 18, 70, 1)',
      fontFamily: 'Poppins',
      fontSize: '10px',
      fontWeight: 400,
      textAlign: 'left',
      '&:hover': {
        backgroundColor: theme.palette.action.hover,
      },
    },    annulerStyle: { 
    width: '100px', height: '40px', backgroundColor: 'rgba(255, 229, 229, 1)',borderRadius:'5.38px', fontFamily: 'Poppins',
    fontSize: '10.76px', fontWeight: 600, color:'rgba(255, 54, 54, 1)',  border : 0,
},
valideStyle: { 
    width: '100px', height: '40px', backgroundColor: 'rgba(60, 101, 86, 1)', color: 'rgba(255, 255, 255, 1)',  
    borderRadius:'5.38px', fontFamily: 'Poppins', fontSize: '10.76px',  fontWeight: 600,  border : 0,
},
viewBtn: {
  width: '40px',
  height: '34px',
  borderRadius: '6px',
  backgroundColor:'rgba(240, 243, 199, 1)',
  border: 0,
  lineHeight: '18px',
  color: 'rgba(187, 200, 8, 1)',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  cursor: 'pointer',
},
 todoListActions: {
        display: 'flex',
        flexDirection: 'row',
        width: '100%',
        height: 100,
        textAlign:'center'
        
    },
        todoSection: {
        flex: 1,
        height: 87,
        padding: 10,
        backgroundColor: 'rgba(255, 255, 255, 1)',
        border: '1px solid rgba(255, 255, 255, 1)',
        opacity: 1,
        fontFamily: 'Poppins',
        fontSize: 12,
        fontWeight: 500,
        lineHeight: '18px',
        color: 'rgba(181, 181, 195, 1)',
        position: 'relative',
        paddingTop: 20,
        paddingBottom:10,
        paddingLeft: 17,
    //     textAlign: 'justify',
    // textJustify: 'inter-word'
    },
    firstSection: {
        borderTopLeftRadius: 9,
        borderBottomLeftRadius: 9,
        paddingTop: 20,
        cursor: 'pointer'
    },
    lastSection: {
        borderTopRightRadius: 9,
        borderBottomRightRadius: 9,
        paddingTop: 20,
        cursor: 'pointer'
    },
    sectionLine: {
        content: '""',
        position: 'absolute',
        top: 7,
        bottom: 5,
        right: 0,
        width: 1,
        backgroundColor: 'rgba(244, 241, 249, 1)',
    },
    sectionText: {
        fontFamily: 'Poppins',
        fontSize: 20,
        fontWeight: 600,
        color: 'rgba(70, 78, 95, 1)',
        display: 'block',
        paddingLeft: 0,
        marginTop: 5,
    },
})); 

const ActionButton = ({ 
  filterByOptionSections, 
  updateStatus, 
  sendToPI, 
  classes 
}) => {
  const handleClick = () => {
    if (filterByOptionSections === "optionValidationSections") {
      updateStatus("APPROVED");
    } else {
      sendToPI();
    }
  };

  const getButtonLabel = () => {
    return filterByOptionSections === "optionValidationSections" 
      ? "Valider Réglement" 
      : "Envoyer à PI";
  };

  return (
    <button 
      className={classes.valideStyle} 
      onClick={handleClick}
    >
      {getButtonLabel()}
    </button>
  );
};
export default function Payment({setIdClaim,setIndexRoute}) {
 
  const dispatch = useDispatch();
    const classes = useStyles(); 
    const [page, setPage] = useState(0);  
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const { paymentData , loading } = useSelector((state) => state.paymentReducer);
    console.log("paymentData : " , paymentData)
    const [checkedGroupe, setCheckedGroupe] =  useState(false);
    const [order, setOrder] = useState("asc"); 
    const [orderBy, setOrderBy] = useState("");
    const [ filterPaymentData , setFilterPaymentData]= useState([]);
    const [openGroupId, setOpenGroupId] = useState(null);
    const [dialogContent, setDialogContent] = useState({});
    const [selected, setSelected] =  useState([]);
    const [openDialog, setOpenDialog] = useState(false); 
    const [test, setTest] = useState(false); 
    const [filterDestinataire, setFilterDestinataire] = useState("");
    const [filterType, setFilterType] = useState("");  
    const getInitialOption = () => {
      if (hasAuthorities("VIEW_FILTER_AWAITING_VALIDATION")) return "optionValidationSections"; 
      if (hasAuthorities("VIEW_FILTER_AWAITING_RETOUR_PI")) return "optionRetourPISections";
      return "";
    };

    const [filterByOptionSections, setFilterByOptionSections] = useState(getInitialOption());
    const [filterStatus, setFilterStatus] = useState("");
    const [filterClaimNumber, setFilterClaimNumber] = useState("");
    const optionValidationSections = [
            { value: 'PENDING',   label: 'En Cours'  },
            { value: 'APPROVED',   label: 'Accepté'  },
            { value: 'REFUSED',   label: 'Réfusé'  }
              ];
    const validationValues = optionValidationSections.map(option => option.value);
    const optionRetourPISections = [
            { value: 'APPROVED', label: 'Accepté' },
            { value: 'PIKO', label: "Échec d'envoi" },
            { value: 'PIOK', label: 'Envoi succès' }
            ];
    const retourPIValues = optionRetourPISections.map(option => option.value); 
    const sections = [
      {
        authority: 'VIEW_FILTER_AWAITING_VALIDATION',
        id: 'optionValidationSections',
        label: 'Liste des missions en attente de validation pour règlement',
        data: paymentData?.filter(item => validationValues.includes(item.status)).length || 0 
      },
      {
        authority: 'VIEW_FILTER_AWAITING_RETOUR_PI',
        id: 'optionRetourPISections',
        label: 'Liste des missions en attente de retour de règlement à PI',
        data: paymentData?.filter(item => retourPIValues.includes(item.status)).length || 0 
      }
    ];
     
    const getStatusStyle = (item) => {
      switch (item.status) {
        case "APPROVED":
          return {
            color: "rgba(187, 200, 8, 1)",
            backgroundColor: "rgba(240, 243, 199, 1)",
          };
        case "REFUSED":
          return {
            color: "rgba(255, 54, 54, 1)",
            backgroundColor: "rgba(255, 229, 229, 1)",
          };
        case "PIOK":
          return {
            color: "rgb(0, 231, 200)",
            backgroundColor: "rgb(201, 243, 199)",
          };
        case "PIKO":
          return {
            color: "rgb(250, 18, 18)",
            backgroundColor: "rgb(250, 201, 201)",
          };
        default:
          return {
            color: "rgba(255, 168, 0, 1)",
            backgroundColor: "rgba(255, 168, 0, 0.3)",
          };
      }
    };


    const handleChangePage = (event, newPage) => {
      setPage(newPage);
    };
  
    const handleChangeRowsPerPage = (event) => {
      setRowsPerPage(parseInt(event.target.value, 10));
    };
    


    async function handleViewClick  (id)  {
      const data = await paymentData.find((item) => item._id === id);
      setDialogContent(data)
      setOpenDialog(true);
    }
    const handleClose = () => {
      setOpenDialog(false);
     };
    function handleRequestSort(event, property) {
      const isDesc = orderBy === property && order === "desc";
      setOrder(isDesc ? "asc" : "desc");
      setOrderBy(property);
    }

    const getAllPayments =   ( ) =>{
     return   dispatch(Actions.getAllPayments());
    }

    const updateCheckedGroupe =(test)=>{
      setCheckedGroupe(test);
      groupData(test, paymentData);
    }

    const validValues = (filterByOptionSections === "optionRetourPISections"
     ? optionRetourPISections
     : filterByOptionSections === "optionValidationSections" 
        ? optionValidationSections : ""
  ).map(opt => opt.value);

  const groupData = (test, dataArray) => {
   setPage(0)
  const filteredData = dataArray.filter(item => validValues.includes(item.status));

  if (!test) {
    setFilterPaymentData(filteredData);
  } else { 
    const groupedData = filteredData.reduce((acc, current) => {
      const key = current.associatedClaim;
      acc[key] = acc[key] || { items: [], totalAmountTcc: 0 };
      acc[key].items.push(current);
      
      // Calculate totalAmountTcc based on item type
      if (current.__t === "paymentInspector") {
        acc[key].totalAmountTcc += current.inspectionAmount || 0;
      } else if (current.__t === "paymentRepair") {
        acc[key].totalAmountTcc += current.totalRepairAmountWTax || 0;
      }
      
      return acc;
    }, {});
    
    const formattedData = Object.keys(groupedData).map((key) => {
      const items = groupedData[key].items;
      let status; 
      
      if (items.every((item) => item.status === "PIOK")) {
        status = "Totalement réglé";
      } else if (items.every((item) => item.status === "REFUSED" || item.status === "PIKO")) {
        status = "Aucun Règlement";
      } else if (items.some((item) => item.status === "APPROVED")) {
        status = "Partiellement Réglé";
      } else {
        status = "En Attente Réglément";
      }
      
      return {
        associatedClaim: key,
        items: groupedData[key].items,
        totalAmountTcc: groupedData[key].totalAmountTcc,
        status,
      };
    });
    
    setFilterPaymentData(formattedData);
  }
  }
 

    const handleClick = (event, id) => {
      const selectedIndex = selected.indexOf(id);
      let newSelected = [];

      if (selectedIndex === -1) {
          newSelected = newSelected.concat(selected, id);
      } else if (selectedIndex === 0) {
          newSelected = newSelected.concat(selected.slice(1));
      } else if (selectedIndex === selected.length - 1) {
          newSelected = newSelected.concat(selected.slice(0, -1));
      } else if (selectedIndex > 0) {
          newSelected = newSelected.concat(
              selected.slice(0, selectedIndex),
              selected.slice(selectedIndex + 1),
          );
      }
      setSelected(newSelected);
  };

  const handleSelectAllClick = (event) => {
      if (event.target.checked) {
          const newSelecteds = filterPaymentData.map((n) => n._id);
          setSelected(newSelecteds);
          return;
      }
      setSelected([]);
  };
const updateStatus = async (status) => {
  if (!selected || selected.length === 0) {
    alert("Merci de choisir un règlement.");
    return;
  }

  for (const id of selected) {
    const result = filterPaymentData.find(item => item._id === id);
    if (!result) {
      console.warn(`Élément avec l'ID ${id} introuvable dans les données.`);
      continue;
    }

    try {
      await dispatch(Actions.updatePaymentStatus(result._id, status ,  ""));
      result.status = status; 
    } catch (error) {
      console.error(`Erreur lors de la mise à jour de l'élément ${result._id} :`, error);
    }
  }
  groupData(checkedGroupe, paymentData);
};

const sendToPI = async () => {
  if (!selected || selected.length === 0) {
    alert("Merci de choisir un règlement.");
    return;
  }

  console.log("selected.length", selected.length);

  for (const id of selected) {
    const result = filterPaymentData.find((item) => item._id === id);
    if (!result) continue;

    try {
      let isSuccess = false;
      let message = "";
      
      if (result.__t === "paymentInspector") {
        const res = await CompleteMissionExpert(result);
        isSuccess = res.success;
        message = res.message || "";
        if (isSuccess) {
          await addPaymentMissionExpert(result);
        }
      } else {
        const res = await CompleteMissionRGA(result);
        isSuccess = res.success;
        message = res.message || "";
      }

      const newStatus = isSuccess ? "PIOK" : "PIKO";
      await dispatch(Actions.updatePaymentStatus(result._id, newStatus, message));

      // Mise à jour locale
      const payment = paymentData.find(p => p._id === result._id);
      if (payment) payment.status = newStatus;

    } catch (error) {
      console.error(`Erreur lors du traitement du paiement ${result._id} :`, error);
    }
  }

  groupData(checkedGroupe, paymentData);
};

    
   useEffect(  () => {
      getAllPayments(); 
   }, [dispatch]);     
    
   useEffect(() => {
      if(!loading){ 
        groupData(checkedGroupe, paymentData )
      }  
   }, [loading ,filterByOptionSections]);
   useEffect(() => {
     
    const filteredData = paymentData.filter(item => {
        const matchesClaimNumber = filterClaimNumber ?
            item?.associatedClaim?.toLowerCase().includes(filterClaimNumber.toLowerCase()) : true;
        const matchesDestinataire = filterDestinataire ?
            item?.repairer?.toLowerCase().includes(filterDestinataire.toLowerCase()) ||
            item?.inspector?.toLowerCase().includes(filterDestinataire.toLowerCase()): true;
        const matchesType = filterType ? item.__t === filterType : true;
        const matchesStatus = filterStatus ? item?.status?.toLowerCase().includes(filterStatus.toLowerCase()) : true;
        return matchesClaimNumber && matchesDestinataire && matchesType && matchesStatus;
    });

    groupData(checkedGroupe, filteredData);
   }, [filterClaimNumber, filterDestinataire, filterType, filterStatus, checkedGroupe, paymentData ,]);
 
    return (
        <div className={classes.root}>
          <div className={classes.todoListActions}>
            {sections.map((section, index) =>
                hasAuthorities(section.authority) && (
                    <div
                        key={section.id}
                        style={{cursor: 'pointer'}}
                        className={`${classes.todoSection} ${index === 0 ? classes.firstSection : ''} ${index === sections.length - 1 ? classes.lastSection : ''}`}
                        onClick={() => setFilterByOptionSections(section.id)}
                    >
                        {section.label} 
                        <span className={classes.sectionText}>{section.data}</span>
                        <span className={classes.sectionLine}></span> 
                    </div>
                )
            )}
            </div>
        <Paper className={classes.paper}>
        <div className={classes.tableWrapper} > 
        <div style={{display:'flex' , flexDirection:'column'    }}>
 
              <div style={{display:'flex', alignItems:'center', marginBottom: '20px', gap: '20px'}}>
                <div className={classes.titre} style={{whiteSpace: 'nowrap'}}>Filtrer par</div>
                <div className={classes.filterContainer}>
                    <div className={classes.filterRow}>
                        <div className={classes.filterItem}>
                            <div className={classes.titreLabel}>N° Sinistre</div>
                            <input
                                type='text'
                                value={filterClaimNumber}
                                onChange={(e) => setFilterClaimNumber(e.target.value)}
                                className={classes.filterInput}
                            />
                        </div>
                        <div className={classes.filterItem}>
                            <div className={classes.titreLabel}>Destinataire</div>
                            <input
                                type='text'
                                value={filterDestinataire}
                                onChange={(e) => {
                                    setFilterDestinataire(e.target.value);
                                    setSelected([]);
                                  }}
                                className={classes.filterInput}
                            />
                        </div>
                        <div className={classes.filterItem}>
                            <div className={classes.titreLabel}>Type</div>
                            <select
                                className={classes.selectInput}
                                onChange={(e) => setFilterType(e.target.value)}
                            >
                                <option className={classes.optionItem} value="">Tout Règlement</option>
                                <option className={classes.optionItem} value="paymentRepair">Règlement Garage</option>
                                <option className={classes.optionItem} value="paymentInspector">Règlement Expert</option>
                            </select>
                        </div>
                        <div className={classes.filterItem}>
                            <div className={classes.titreLabel}>Statut</div>
                            <select
                                className={classes.selectInput}
                                value={filterStatus}
                                onChange={(e) => setFilterStatus(e.target.value)}
                            >
                               <option className={classes.optionItem} value="">Tout Statut</option>
                                {filterByOptionSections==="optionValidationSections" ?( optionValidationSections.map(({ value, label }) => (
                                    <option key={value} className={classes.optionItem} value={value}>
                                        {label}
                                    </option>
                                )) ) :
                                ( optionRetourPISections.map(({ value, label }) => (
                                    <option key={value} className={classes.optionItem} value={value}>
                                        {label}
                                    </option>
                                )) ) }
                            </select>
                        </div>
                    </div>
                </div>
                <div style={{display:'flex', alignItems:'center', gap: '20px'}}>
                    <div className={classes.titreLabel} style={{whiteSpace: 'nowrap'}}>Affichage groupé
                        <ToggleSwitch id="switch" checked={checkedGroupe} onChange={checkedGroupe => updateCheckedGroupe(checkedGroupe)}  />
                    </div>
                    <div style={{display:'flex', gap: '10px'}}>
                        <button className={classes.annulerStyle} onClick={() => updateStatus("REFUSED")}>Rejeter</button>
                        <ActionButton
                          filterByOptionSections={filterByOptionSections}
                          updateStatus={updateStatus}
                          sendToPI={sendToPI}
                          classes={classes}
                        />
                    </div>
                </div>
              </div>
        </div>
        
            <Table
              className={classes.table}
              aria-labelledby="tableTitle"
              size="small"
            >
              <EnhancedTableHead
                order={order}
                orderBy={orderBy}
                onRequestSort={handleRequestSort}
                checkedGroupe={checkedGroupe}
                onSelectAllClick={handleSelectAllClick}
                numSelected={selected.length}
                rowCount={filterPaymentData.length}
              />
    {loading ? 
      <TableBody>
      {[...Array(10)].map((row, index) => {
            return (
              <tr
                hover 
                style={{ height: "48px"   }}
              > 
                <TableCell
                  align="left"
                  className={classes.tableCellSmall}
                >
                    <Skeleton animation="wave" />
                </TableCell>    
                <TableCell
                  align="left"
                  className={classes.tableCellSmall}
                >
                    <Skeleton animation="wave" />
                </TableCell>                 
                
                <TableCell
                  align="left"
                  className={classes.tableCellSmall}
                >
                  <Skeleton animation="wave" />
                </TableCell>
                <TableCell
                  align="left"
                  className={classes.tableCellSmall}
                >
                    <Skeleton animation="wave" />
                </TableCell>
                <TableCell
                  align="right"
                  className={classes.tableCellSmall}
                >
                  <Skeleton animation="wave" />
                </TableCell>
                <TableCell
                  align="right"
                  className={classes.tableCellSmall}
                >
                  <Skeleton animation="wave" />
                </TableCell>
              </tr>
            );
          })}
      </TableBody>
     :<>  
     {filterPaymentData != null && filterPaymentData.length > 0 ?  
        <>  {checkedGroupe ?
          <TableBody>
  {filterPaymentData.map((row, index) => {
    return (
      <>
                <tr
                  hover
                  //tabIndex={-1}
                  key={row._id || index}
                  style={{ height: "60px" }}
                >
                  <TableCell
                    align="left"
                    className={classes.tableCellSmall}
                  >
                    <IconButton
                      aria-label="expand row"
                      size="small"
                      onClick={() => setOpenGroupId(openGroupId === row.associatedClaim ? null : row.associatedClaim)}
                      style={{
                        backgroundColor: "rgba(243, 246, 249, 1)",
                        width: "25px",
                        height: "25px",
                        borderRadius: "6px",
                        color: "rgba(187, 200, 8, 1)",
                        marginRight: "10px",
                      }}
                    >
                      {openGroupId === row.associatedClaim ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                    </IconButton>
                    {row.associatedClaim || "N/A"}
                  </TableCell>
                  <TableCell
                    align="left"
                    className={classes.tableCellSmall}
                  >
                    {row.totalAmountTcc || "N/A"}
                  </TableCell>
                  <TableCell
                    align="center"
                    className={classes.tableCellSmall}
                  >
                    <span
                      style={{
                        padding: "10px",
                        borderRadius: "51px",
                        background: "rgba(240, 243, 199, 1)",
                        border: 0,
                        fontFamily: "Poppins",
                        fontSize: "10.17px",
                        fontWeight: 500,
                        lineHeight: "15.26px",
                        color: "rgba(187, 200, 8, 1)",
                      }}
                    >
                      {row.status || "N/A"}
                    </span>
                  </TableCell>
                  <TableCell
                    align="center"
                    className={classes.tableCellSmall}
                  ></TableCell>
                </tr>
                <tr>
                  <TableCell style={{ padding: 0 }} colSpan={6}>
                    <Collapse in={openGroupId === row.associatedClaim} timeout="auto" unmountOnExit>
                      <Table size="small" style={{ background: "rgba(243, 246, 249, 1)" }}>
                        <tr  >
                          <TableCell align="left" className={classes.tableCellSmallCollapseHead}>
                            Type
                          </TableCell>
                          <TableCell align="left" className={classes.tableCellSmallCollapseHead}>
                            Montant
                          </TableCell>
                          <TableCell align="center" className={classes.tableCellSmallCollapseHead}>
                            Statut
                          </TableCell>
                          <TableCell align="center" className={classes.tableCellSmallCollapseHead}>
                            {""}
                          </TableCell>
                        </tr>
                        <TableBody>
                          {row.items.map((item ,index) => {
                            const isItemSelected = selected.indexOf(item._id)!== -1;
                            const labelId = `enhanced-table-checkbox-${index}`;
                            return (
                              <tr key={item.date}  >
                                 
                                <TableCell align="left"   className={classes.tableCellSmallCollapse}>
                                    <Checkbox
                                        checked={isItemSelected}
                                        onChange={(event) => handleClick(event, item._id)}
                                        inputProps={{ "aria-labelledby": labelId }}
                                        sx={{
                                            color: 'rgb(255, 255, 255)' ,
                                            opacity: '.7' ,
                                            width: '16px',
                                            height: '16px' ,
                                            gap: 0 ,
                                            borderRadius:' 4px' ,
                                            border: '1px solid' ,
                                        }}
                                        style={{marginRight : '10px'}}
                                      />
                                      {item.__t === "paymentRepair"? "Règlement Garage" : "Règlement Expert"}
                                </TableCell>
                                <TableCell align="left" className={classes.tableCellSmallCollapse}>
                                {item.__t==="paymentRepair" ? item.totalAmountTcc ||"N/A" : item.inspectionAmount ||"N/A" }{" TND"}
                                
                                </TableCell>
                                  <TableCell align="center" className={classes.tableCellSmallCollapse}>
                                  <span
                                    style={{
                                      padding: "5px",
                                      borderRadius: "51px",
                                      border: 0,
                                      fontFamily: "Poppins",
                                      fontSize: "10.17px",
                                      fontWeight: 400,
                                      lineHeight: "15.26px",
                                       ...getStatusStyle(item)
                                       
                                    }}
                                  >
                                    {translateReplacementCarStatus(item.status)}
                                  </span>
                                </TableCell>  
                                <TableCell
                                      align="center"
                                      className={classes.tableCellSmall}> 
                                          <button className={classes.viewBtn} style={{marginLeft: '7px'}}
                                               onClick={() => handleViewClick(item._id)} >
                                                  <AiOutlineEye/>
                                          </button>
                                      </TableCell>
                              </tr>
                            );
                          })}
                        </TableBody>
                      </Table>
                    </Collapse>
                  </TableCell>
                </tr>
              </>
            );
          })}
        </TableBody> 
       :
       <TableBody>
       { stableSort(filterPaymentData, getSorting(order, orderBy))
       .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
       .map((row, index) => {
        const isItemSelected = selected.indexOf(row._id) !== -1;
        const labelId = `enhanced-table-checkbox-${index}`;
           return (
             <tr
               hover
               //tabIndex={-1}
               style={{height: "50px"}}
               key={row._id || index} 
               onClick={(event) => handleClick(event, row.id)}
               role="checkbox"
               aria-checked={isItemSelected}
               tabIndex={-1} 
               selected={isItemSelected}
               sx={{ cursor: 'pointer' , }}
             > 
              <TableCell padding="checkbox"  className={classes.tableCellSmall}>
                    <Checkbox
                        checked={isItemSelected}
                        onChange={(event) => handleClick(event, row._id)}
                        inputProps={{"aria-labelledby": labelId}}
                        sx={{
                            color: 'rgb(255, 255, 255)' ,
                            opacity: '.7' ,
                            width: '16px',
                            height: '16px' ,
                            gap: 0 ,
                            borderRadius:' 4px' ,
                            border: '1px solid' ,
                        }} />
              </TableCell>
               <TableCell
                 align="left"
                 className={classes.tableCellSmall}
               >
                  {row.__t==="paymentRepair" ? "Règlement Garage" :  "Règlement Expert" } 
               </TableCell>    
               <TableCell
                 align="left"
                 className={classes.tableCellSmall}
               >
                 {row.associatedClaim    ||"N/A"}
               </TableCell>                 
               <TableCell
                 align="left"
                 className={classes.tableCellSmall}
               >
                 {row.__t==="paymentRepair" ? row.repairer ||"N/A" : row.inspector ||"N/A" }
               </TableCell>
               <TableCell
                 align="left"
                 className={classes.tableCellSmall}
               > 
                 {row.__t==="paymentRepair" ? row.totalAmountTcc ||"N/A" : row.inspectionAmount ||"N/A" }{" TND"}
               </TableCell>
               <TableCell
                 align="center"
                 className={classes.tableCellSmall}
               > 
                  <span style={{
                    padding: "10px", borderRadius: '51px', border: 0, fontFamily: 'Poppins', fontSize: '10.17px',  fontWeight: 500, lineHeight: '15.26px',
                     ...getStatusStyle(row)  }}>
                    {translateReplacementCarStatus(row.status)}
                  </span>  
                        
                   
                 
               </TableCell>
               <TableCell
                 align="center"
                 className={classes.tableCellSmall}> 
                    <button className={classes.viewBtn} style={{marginLeft: '7px'}}
                                                                onClick={() => handleViewClick(row._id)}
                                                        >
                            <AiOutlineEye/>
                    </button>
                </TableCell>
             </tr>
           );
         })}
        </TableBody> 
            } </>
       :<TableBody>
       <TableCell
                align="left"
                style={{fontFamily : 'Poppins', fontWeight : 400 ,fontSize :15, lineHeight:'22.5px' ,color :'rgba(70, 78, 95, 1)' , padding :'20px' }}
                colspan="7"
              > {" "}
              Aucune Réglements disponible
              </TableCell></TableBody>}
      </>}
            </Table>
           { checkedGroupe ?
             <></> :
             <TablePagination
                rowsPerPageOptions={[10, 20, 30]}
                component="div"
                count={filterPaymentData?.length || 0}
                rowsPerPage={rowsPerPage}
                page={page}
                backIconButtonProps={{
                  "aria-label": "Previous Page",
                }}
                nextIconButtonProps={{
                  "aria-label": "Next Page",
                }}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                style={{
                  fontFamily: "Poppins",
                  fontSize: "12px",
                  fontWeight: 400,
                  lineHeight: "18px",
                  color: "rgba(32, 18, 70, 1)",
                }}
                labelRowsPerPage="Lignes par page"
            /> }
          </div>
        </Paper>
        
        <Dialog
          open={openDialog}
          onClose={handleClose}
          maxWidth={"xl"}
          PaperProps={{ style: { width: 600 } }}>
                 
                    {dialogContent.__t === "paymentRepair" ? 
                    <PaymentGarage isTaskClaimed={false}  data={dialogContent} setAction={handleClose} actionPI  = {filterByOptionSections === "optionRetourPISections"}/> 
                    : 
                    <PaymentExpert isTaskClaimed={false} data={dialogContent} setAction={handleClose}  actionPI  = {filterByOptionSections === "optionRetourPISections"}/>}
                 
        </Dialog>
      </div>
    )
}